<template>
  <LegalPageShell
    title="Termos de serviço"
    subtitle="Condições gerais de uso da plataforma GetLance."
    :alternate-legal-link="{ to: '/politica-de-privacidade', label: 'Política de privacidade' }"
  >
    <p class="text-neutrals_text/70 text-xs sm:text-sm">
      Última atualização: 10 de maio de 2026. Texto modelo para publicação no mesmo domínio do produto e para
      cadastros que exijam URL de termos (ex.: Google OAuth). Adequação jurídica recomendada antes do uso definitivo.
    </p>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">1. Aceitação</h2>
      <p>
        Ao acessar ou usar o site, aplicativos ou serviços da <strong>GetLance</strong> em
        <strong>getlance.com.br</strong>, você declara ter lido e concordado com estes Termos. Se não concordar,
        interrompa o uso.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">2. Descrição do serviço</h2>
      <p>
        A GetLance oferece ferramentas para divulgação, contratação e gestão de relacionamentos entre prestadores de
        serviços e contratantes. A plataforma pode incluir funcionalidades de pagamento, agendamento, mensagens e
        integrações com terceiros (incluindo provedores de identidade e APIs Google quando ativadas pelo usuário ou
        administrador da conta).
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">3. Conta e responsabilidades</h2>
      <ul class="list-disc pl-5 space-y-2">
        <li>Você é responsável pela veracidade das informações fornecidas e pela segurança de suas credenciais.</li>
        <li>É proibido usar a plataforma para fins ilícitos, spam, fraude, violação de direitos de terceiros ou
          distribuição de malware.</li>
        <li>O relacionamento contratual entre prestador e contratante é principalmente entre essas partes; a GetLance
          atua como intermediadora tecnológica, salvo disposição específica em contrato ou lei.</li>
      </ul>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">4. Conteúdo e propriedade intelectual</h2>
      <p>
        Marcas, layout, software e demais conteúdos da GetLance são protegidos. Conteúdos enviados por usuários
        permanecem de sua titularidade, concedendo à GetLance licença não exclusiva para hospedar, exibir e operar o
        serviço, no limite necessário.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">5. Pagamentos</h2>
      <p>
        Transações financeiras podem ser processadas por parceiros. Taxas, prazos de liquidação e políticas de
        reembolso seguem as regras exibidas no fluxo de pagamento e documentos complementares aplicáveis.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">6. Limitação de responsabilidade</h2>
      <p>
        Na medida permitida pela lei aplicável, a GetLance não se responsabiliza por danos indiretos, lucros cessantes
        ou interrupções causadas por terceiros, casos fortuitos ou força maior. O serviço é oferecido &quot;no estado em
        que se encontra&quot;, com esforços razoáveis de disponibilidade.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">7. Suspensão e encerramento</h2>
      <p>
        Podemos suspender ou encerrar contas que violem estes Termos, a legislação ou políticas internas, mediante
        comunicação quando possível, sem prejuízo de medidas legais.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">8. Lei e foro</h2>
      <p>
        Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de domicílio
        da GetLance, salvo disposição legal consumerista em contrário.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">9. Contato</h2>
      <p>
        Dúvidas sobre estes Termos: envie um e-mail para
        <a href="mailto:contato@getlance.com.br" class="text-primary underline hover:no-underline">contato@getlance.com.br</a>.
      </p>
    </section>
  </LegalPageShell>
</template>

<script>
import LegalPageShell from '@/components/LegalPageShell.vue';

export default {
  name: 'TermsOfServicePage',
  components: { LegalPageShell },
  mounted () {
    document.title = 'Termos de serviço | GetLance';
  },
};
</script>
